// Modifier B section form field enum
export enum ModifierBFormField {
  MODIFIER_B_1_QUESTION = 'modifierB/question1',
  MODIFIER_B_1_NOTES = 'modifierB/notes1',
  MODIFIER_B_2_QUESTION = 'modifierB/question2',
  MODIFIER_B_2_NOTES = 'modifierB/notes2',
  MODIFIER_B_3_QUESTION = 'modifierB/question3',
  MODIFIER_B_3_NOTES = 'modifierB/notes3',
  MODIFIER_B_4_QUESTION = 'modifierB/question4',
  MODIFIER_B_4_NOTES = 'modifierB/notes4',
  MODIFIER_B_5_QUESTION = 'modifierB/question5',
  MODIFIER_B_5_NOTES = 'modifierB/notes5',
  MODIFIER_B_6_QUESTION = 'modifierB/question6',
  MODIFIER_B_6_NOTES = 'modifierB/notes6',
  MODIFIER_B_7_QUESTION = 'modifierB/question7',
  MODIFIER_B_7_NOTES = 'modifierB/notes7'
}
